import { memo, ReactElement } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

export interface SessionExtendDialogProps {
  isOpen: boolean;
  onExtendSession: () => void;
  onCloseDialog: () => void;
}

export const SessionExtendDialog = memo(function SessionExtendDialog({
  isOpen,
  onExtendSession,
  onCloseDialog,
}: SessionExtendDialogProps): ReactElement {
  return (
    <Dialog open={isOpen} onClose={onCloseDialog}>
      <DialogTitle>
        <Typography variant='h6' component='div'>
          Sitzung verlängern
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant='body1'>
          Ihre Sitzung läuft in weniger als einer Minute ab. Möchten Sie die Sitzung verlängern?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onExtendSession} color='primary' variant='contained'>
          Verlängern
        </Button>
      </DialogActions>
    </Dialog>
  );
});
